import { createAction } from 'redux-actions';

const actions = {
  /**
   * [정산] 정산 데이터 변경하기
   */
  SET_DATA: 'balance/SET_DATA',
  setData: createAction('balance/SET_DATA'),

  /**
   * [정산 리스트] 정산 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST: 'balance/GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST',
  getBalanceListExcelDownload: createAction('balance/GET_BALANCE_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [정산 리스트] 정산 아이템 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST: 'balance/GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getBalanceItemListExcelDownload: createAction('balance/GET_BALANCE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * [정산 상세] 정산 상세 요청하기
   */
  GET_BALANCE_DETAIL_REQUEST: 'balance/GET_BALANCE_DETAIL_REQUEST',
  GET_BALANCE_DETAIL_SUCCESS: 'balance/GET_BALANCE_DETAIL_SUCCESS',
  getBalanceDetail: createAction('balance/GET_BALANCE_DETAIL_REQUEST'),

  /**
   * [정산 상세]정산 상세 업데이트하기
   */
  EDIT_BALANCE_DETAIL_REQUEST: 'balance/EDIT_BALANCE_DETAIL_REQUEST',
  editBalanceDetail: createAction('balance/EDIT_BALANCE_DETAIL_REQUEST'),

  /**
   * [정산 브랜드 리스트] 정산 브랜드 리스트 요청하기
   */
  GET_BALANCE_BRAND_LIST_REQUEST: 'balance/GET_BALANCE_BRAND_LIST_REQUEST',
  GET_BALANCE_BRAND_LIST_SUCCESS: 'balance/GET_BALANCE_BRAND_LIST_SUCCESS',
  getBalanceBrandList: createAction('balance/GET_BALANCE_BRAND_LIST_REQUEST'),

  /**
   * [정산 브랜드 리스트] 정산 브랜드 리스트 엑셀 다운로드 요청하기
   */
  GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST: 'balance/GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST',
  getBalanceBrandListExcelDownload: createAction('balance/GET_BALANCE_BRAND_LIST_EXCEL_DOWNLOAD_REQUEST'),

  /**
   * 모달 토글
   */
  TOGGLE_MODAL: 'balance/TOGGLE_MODAL',
  toggleModal: createAction('balance/TOGGLE_MODAL'),
};

export default actions;
